(() => {
  if (!customElements.get("currency-switcher")) {
    class CurrencySwitcher extends HTMLElement {
      constructor() {
        super();
        this.initialise();
      }

      /**
       * initialise
       * @description Initialises the currency-switcher.
       */
      initialise() {
        this.globalHeader = document.querySelector("[data-header]");
        this.elements = {
          input: this.querySelector("[data-country-code]"),
          button: this.querySelector("[data-button]"),
          panel: this.querySelector("[data-panel]"),
          links: this.querySelectorAll("[data-currency-link]"),
          form: this.querySelector("form"),
        };

        if (document.documentElement.classList.contains("touch")) {
          // For devices without a mouse, register click event.
          this.elements.button.addEventListener("click", this.button_handleClick.bind(this));
        } else {
          // For devices with a mouse, register mouse over/out events.
          this.addEventListener("mouseover", this.element_handleMouseEnter.bind(this));
          this.addEventListener("mouseout", this.element_handleMouseLeave.bind(this));
        }

        for (const link of this.elements.links) {
          link.addEventListener("click", this.item_handleClick.bind(this));
        }
      }

      /**
       * item_handleClick
       * @description Handles the user clicking a currency item.
       * @param {Event} e click event.
       */
      item_handleClick(e) {
        e.preventDefault();
        this.elements.input.value = e.currentTarget.dataset.value;
        this.elements.form.submit();
      }

      /**
       * button_handleClick
       * @description Handles the clicking of the button.
       */
      button_handleClick() {
        this.toggleSelector();
      }

      /**
       * element_handleMouseEnter
       * @description Handles the 'mouseover' event of the currency-switcher.
       */
      element_handleMouseEnter() {
        this.openSelector();
      }
      /**
       * element_handleMouseLeave
       * @description Handles the 'mouseleave' event of the currency-switcher.
       */
      element_handleMouseLeave() {
        this.closeSelector();
      }

      /**
       * toggleSelector
       * @description Toggles the visibility of the Selector dropdown.
       */
      toggleSelector() {
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (this.elements.button.getAttribute("aria-expanded") === "false").toString(),
        );
      }

      /**
       * openSelector
       * @description Shows the Selector dropdown.
       */
      openSelector() {
        this.elements.panel.removeAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (this.elements.button.getAttribute("aria-expanded") === "false").toString(),
        );
        this.globalHeader.classList.add("header--is-open");
      }

      /**
       * closeSelector
       * @description Closes the Selector dropdown.
       */
      closeSelector() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
        this.globalHeader.classList.remove("header--is-open");
      }
    }

    customElements.define("currency-switcher", CurrencySwitcher);
  }
})();
